function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#c92941}.cls-4{stroke:none}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_15491",
  "data-name": "Group 15491",
  transform: "translate(-320.378 -2791.901)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_3523",
  fill: "#fff",
  stroke: "#1b1464",
  strokeWidth: "4px",
  "data-name": "Rectangle 3523",
  transform: "translate(320.378 2791.901)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 71.72,
  height: 13.149,
  className: "cls-4",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 67.72,
  height: 9.149,
  x: 2,
  y: 2,
  fill: "none",
  rx: 1
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4453",
  "data-name": "Group 4453",
  transform: "translate(326.355 2798.476)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Subtraction_3",
  fill: "#fff",
  "data-name": "Subtraction 3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.255 57.768h-5.8c-.246-.563-.598-1.08-1.046-1.528-.943-.942-2.195-1.462-3.526-1.462-2.04 0-3.798 1.231-4.57 2.99h-5.8c-.246-.563-.598-1.08-1.046-1.528-.942-.942-2.195-1.462-3.526-1.462-2.04 0-3.797 1.231-4.57 2.99h-8.37L2 57.763 2 2h55.766v55.766l-.001.001h-8.369c-.246-.562-.598-1.08-1.045-1.526-.943-.943-2.195-1.463-3.526-1.463-2.04 0-3.798 1.232-4.57 2.99z",
  className: "cls-4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  d: "M39.097 55.768c1.264-1.807 3.36-2.99 5.728-2.99 1.865 0 3.62.728 4.94 2.049.293.293.557.608.79.94h5.211V4H4v51.767h5.213c1.265-1.806 3.361-2.989 5.728-2.989 1.865 0 3.62.728 4.94 2.048.294.294.558.608.792.941h3.482c1.265-1.806 3.36-2.989 5.728-2.989 1.865 0 3.62.728 4.94 2.048.294.294.558.609.792.942h3.482m2.74 4h-8.965c0-.798-.312-1.548-.877-2.113s-1.315-.877-2.112-.877c-1.648 0-2.988 1.341-2.988 2.99H17.93c0-.798-.312-1.548-.877-2.113s-1.315-.877-2.112-.877c-1.648 0-2.988 1.341-2.988 2.99H2c-1.103 0-2-.898-2-2.002V0h59.766v57.766c0 1.104-.897 2.001-2 2.001h-9.953c-.001-.797-.312-1.547-.877-2.112-.565-.565-1.315-.877-2.111-.877-1.648 0-2.989 1.341-2.989 2.99z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4455",
  "data-name": "Group 4455",
  transform: "translate(13.447 11.953)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3521",
  width: 32.872,
  height: 5.977,
  className: "cls-3",
  "data-name": "Rectangle 3521",
  rx: 2.988
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3522",
  width: 32.872,
  height: 5.977,
  className: "cls-3",
  "data-name": "Rectangle 3522",
  rx: 2.988,
  transform: "translate(0 11.953)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3524",
  width: 17.93,
  height: 5.977,
  className: "cls-3",
  "data-name": "Rectangle 3524",
  rx: 2.988,
  transform: "translate(0 23.907)"
}))));

var SvgBillPayment = function SvgBillPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71.72,
    height: 66.343,
    viewBox: "0 0 71.72 66.343",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBillPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billPayment.fe00ae02.svg";
export { ForwardRef as ReactComponent };